import { FC } from 'react'

import { Button, Stack, Typography, useTheme } from '@mui/material'
import { LoadingButton } from '@mui/lab'

import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { CustomTextField } from 'src/@core/components/mui/text-field'

import { useMentorCloudCreateFolderForm } from 'src/hooks/files/useMentorCloudCreateFolderForm'

interface MentorCloudCreateFolderFormProps {
  parentFolderId?: number | null
  onCancel: () => void
}

export const MentorCloudCreateFolderForm: FC<MentorCloudCreateFolderFormProps> = props => {
  const { parentFolderId = null, onCancel } = props

  const theme = useTheme()

  const { t: tAction } = useTranslation()
  const { t } = useTranslation('translation', { keyPrefix: 'PAGE.MENTORCLOUD' })

  const { control, onSubmit, isSubmitting } = useMentorCloudCreateFolderForm(parentFolderId)

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        onSubmit(onCancel)(e)
      }}
      autoComplete='off'
    >
      <Stack gap={theme.spacing(4)}>
        <Typography>{t('header.create_folder')}</Typography>
        <Controller
          control={control}
          name='name'
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <CustomTextField
              fullWidth
              value={value}
              onChange={onChange}
              placeholder={t('placeholder.new_folder')}
              error={Boolean(error)}
              helperText={error && t('error.folder_name_is_required')}
            />
          )}
        />
        <Stack direction={'row'} gap={theme.spacing(2)} justifyContent={'end'} width={'100%'}>
          <Button onClick={onCancel}>{tAction('ACTION.cancel')}</Button>
          <LoadingButton variant='contained' loading={isSubmitting} onClick={onSubmit(onCancel)}>
            {tAction('ACTION.save_n_close')}
          </LoadingButton>
        </Stack>
      </Stack>
    </form>
  )
}
